import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";

export default function SettlementPaymentsFieldLabel({ value }) {
  return (
    <Typography className="text-[14px] font-normal" style={{ color: HNSColors.neutrals[400] }}>
      {value}
    </Typography>
  );
}

